import * as React from 'react';
import { connect } from 'react-redux';
import { NavLink, Redirect } from 'react-router-dom';
import { loginRequest } from '../actions/auth';
import { withTranslation } from 'react-i18next';
import Helmet from 'react-helmet';

interface IInputs {
    username: string,
    password: string,
    [key: string]: any
};

interface IState {
    inputs: IInputs,
    errors: IInputs,
    redirectToCabinet: boolean,
    isLoading: boolean,
    [key: string]: any
};

class Login extends React.Component<any, any> {
    private _isUnmounted: boolean = false;

    public state: IState = {
        inputs: {
            username: "",
            password: "",

        },
        errors: {
            username: "",
            password: "",

        },
        redirectToCabinet: false,
        isLoading: false,
    }

    componentWillUnmount() {
        this._isUnmounted = true;
    }

    validateInput(name: string, value: string) {

        return new Promise<any>((ok: any, error: any): any => {
            this.setState({
                errors: {
                    ...this.state.errors,
                    [name]: value == "" ? (this.props.t("Необходимо заполнить") + " «" + this.props.t(name) + "»") : ""
                }
            }, () => {
                ok();
            });
        });
    }

    changeHandler(event: any) {
        let name = event.target.name;
        let value = event.target.value;

        this.validateInput(name, value).then(() => {
            this.setState({
                inputs: {
                    ...this.state.inputs,
                    [name]: value
                }
            });
        });
    }

    async submitHandler(event: any) {
        let hasError = false;

        for (let property in this.state.inputs) {
            await this.validateInput(property, this.state.inputs[property]);
        }

        for (let property in this.state.errors) {
            if (this.state.errors[property] != "") {
                hasError = true;
                break;
            }
        }

        if (!hasError) {
            this.setState({
                isLoading: true
            }, async () => {
                let response = await this.props
                    .loginRequest({
                        username: this.state.inputs.username,
                        password: this.state.inputs.password
                    });

                if (response.data.status == "error") {
                    this.setState({
                        errors: {
                            username: response.data.message
                        },
                        isLoading: false
                    });
                }
            });



        }
    }

    async facebookCallback(res: any) {
        try {
            if (!this._isUnmounted)
                this.setState({
                    // isLoading: true
                }, async () => {
                    let response = await this.props
                        .facebookRequest({
                            user_id: res.userID,
                            email: res.email,
                            first: res.name.split(" ").shift(),
                            last: res.name.split(" ").pop(),
                            gender: 0
                        });

                    if (response.data.status == "error") {
                        if (!this._isUnmounted)
                            this.setState({
                                errors: {
                                    username: response.data.message
                                },
                                isLoading: false
                            });
                    }
                });
        } catch (err) {
            this.setState({
                isLoading: false
            });
        }
    }

    render() {

        const { t } = this.props;

        return (
            <div className="i-body">
                {this.props.auth.isAuthentificated && <Redirect to="/" />}

                <div className="admin-index">
                    <div className="admin-index__bg"></div>
                    <div className="admin-index__content">
                        <div className="login">
                            <div className="admin-index__logo">
                                <img src="/img/admin_index_logo.png" alt="" />
                            </div>
                            <form onSubmit={(e: any) => {
                                e.preventDefault();

                                this.submitHandler(e);
                            }}>
                                <input name="username" autoComplete="off" type="text" onChange={(e: any) => this.changeHandler(e)} onBlur={(e: any) => this.changeHandler(e)} value={this.state.inputs.username} className="form-control" placeholder={t("Логин")} />
                                <p className="help-block help-block-error text-danger">{this.state.errors.username}</p>
                                <br />
                                <input name="password" type="password" autoComplete="off" onChange={(e: any) => this.changeHandler(e)} onBlur={(e: any) => this.changeHandler(e)} value={this.state.inputs.password} className="form-control" placeholder={t("Пароль")} />
                                <p className="help-block help-block-error text-danger">{this.state.errors.password}</p>
                                <div className="login__items">
                                    <a role="button">Регистрация</a>
                                    <div className="login__item">
                                        <a role="button">Забыл пароль?</a>
                                        <button type="submit">
                                            {this.state.isLoading ? (
                                                <i className="fa fa-spinner fa-2x rotating "></i>
                                            ) : t("Войти")}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        auth: state.auth
    };
}

export default connect(mapStateToProps, { loginRequest })(withTranslation()(Login));